<div class="zen-main-container flex flex-row items-stretch Page overflow-x-hidden">
  <ng-content></ng-content>
</div>
